// extracted by mini-css-extract-plugin
export default {"errorIcon":"rT3a5aw0z52zxcNxq1hu","errorText":"ZQ8tarzQKg_1cSocN7Qv","successIcon":"e2yXYEliRhecRKuee5mC","successText":"H6pzaIAhv1Ly9ROjqSs8"};